import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../editorconfig';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-idex-rfp-soc',
  standalone: false,
  templateUrl: './idex-rfp-soc.component.html',
  styleUrl: './idex-rfp-soc.component.scss'
})
export class IdexRfpSocComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() stepCompleted = new EventEmitter<void>();
  @Output() generatePDFEmitter = new EventEmitter<any>();
  @Output() pocRequiredChanged = new EventEmitter<boolean>();
  @Output() IRA = new EventEmitter<any>();
  @Output() routeConfig = new EventEmitter<any>();
  @Input() isEditable = false;
  @Input() stepDetails: any;
  @ViewChild('pdfContent') pdfContent!: ElementRef;
  isEditorDisabled = false;
  init: EditorComponent['init'] = init;
  pdsTitleData = '';
  SOCForm!: FormGroup;
  RFPForm!: FormGroup;
  POCForm!: FormGroup;
  items = [
    { label: 'SoC', icon: 'pi pi-file-o', command: () => this.getSOCdata() },
    { label: 'RFP', icon: 'pi pi-file-o', command: () => this.getRFPdata() }
  ];
  apiUrl = environment.APIUrl;
  payload: any;
  @Input() proposalName: any;
  @Input() masterData: any;
  @Input() step: any;
  @Input() schemeType: any;
  PDSactiveIndex = 0;
  socID: any;
  rfpID: any;
  stages: any;
  isSkipStep = false;
  currentUserRoleId: any;
  pocstages: any;
  private subscriptions = new Subscription();
  userID: any;
  /** Mode of tender from draft-rfp API; hide vendor management when "Open Tender" or "Single Tender" */
  modeOfTender: string | null = null;
  constructor(private fb: FormBuilder, private messageService: MessageService, private api: ApiService, private route: ActivatedRoute) {
    this.userID = sessionStorage.getItem('user_role_id');
  }
  ngOnInit() {
    this.SOCForm = this.fb.group({ comment: ['', Validators.required] });
    this.RFPForm = this.fb.group({ comment: ['', Validators.required], noting: [''], poc_required: [false] });
    this.POCForm = this.fb.group({ comment: ['', Validators.required] });
    this.route.queryParams.subscribe(params => { this.payload = { proposal_id: params['id'], proposal_name: params['name'] } });
    this.currentUserRoleId = sessionStorage.getItem('user_role_id');
    // For schemeType rev/revenue: hide SoC tab and default to RFP
    if (this.schemeType === 'rev' || this.schemeType === 'revenue') {
      this.PDSactiveIndex = 1;
      this.getRFPdata();
    } else {
      this.getSOCdata();
    }
  }
  expandedSections: { [k: string]: boolean } = { basicInfo: true, equipment: false, quantity: false, cost: false, detailedInfo: false, uploads: false, vendorTable: false };
  toggleSection(s: string) { this.expandedSections[s] = !this.expandedSections[s]; }
  ngOnDestroy() { this.subscriptions.unsubscribe(); }
  ngAfterViewInit() {
    setTimeout(() => {
      this.isEditorDisabled = !this.stepDetails.can_edit;
      (this.isEditorDisabled ? this.RFPForm.disable() : this.RFPForm.enable());
      (this.isEditorDisabled ? this.SOCForm.disable() : this.SOCForm.enable());
      this.rebuildEditor();
    }, 3000);
  }
  editorReady = false;
  rebuildEditor() {
    this.editorReady = false;
    setTimeout(() => {
      this.init = { ...this.init, ...this.getTinyInit() };
      this.editorReady = true;
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] { return { readonly: this.isEditorDisabled }; }
  goToNextStep() { this.stepCompleted.emit(); }
  onPDSActiveIndexChange(e: number) { this.PDSactiveIndex = e; if (e == 1) this.getRFPdata(); }
  generatePDF() {
    this.generatePDFEmitter.emit({
      url: '/revenue/need/version-control/',
      data: [
        { key: "Proposal Name", value: this.proposalName },
        { key: "RFP Details", value: this.RFPForm.get('comment')?.value },
        { key: "SOC Details", value: this.SOCForm.get('comment')?.value }
      ]
    });
  }
  onSubmit(index: number) {
    if (index == 0 && this.SOCForm.valid) {
      let s = this.masterData.find((i: any) => i.name === 'SOC');
      let payload = { proposal_step: this.step.id, comment: this.SOCForm.get('comment').value, css_file_path: s?.style || '' };
      const obs = this.socID ?
        this.api.putAPI(`/revenue/draft-soc/${this.socID}/`, payload) :
        this.api.postAPI(`/revenue/draft-soc/`, payload);
      const sub = obs.subscribe((res: any) => {
        if (res) {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Form submitted sucessfully' });
          this.getSOCdata();
          this.PDSactiveIndex = 1;
          this.getRFPdata();
        }
      }); this.subscriptions.add(sub);
    } else if (index == 1) {
      let s = this.masterData.find((i: any) => i.name === 'RFP');
      let payload = { proposal_step: this.step.id, comment: this.RFPForm.get('comment').value, noting: this.RFPForm.get('noting').value, css_file_path: s?.style || '' };
      const obs = this.rfpID ?
        this.api.putAPI(`/revenue/draft-rfp/${this.rfpID}/`, payload) :
        this.api.postAPI(`/revenue/draft-rfp/`, payload);
      const sub = obs.subscribe((res: any) => {
        if (res) {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Form submitted sucessfully' });
          this.getRFPdata();
          this.RFPForm.get('poc_required')?.valueChanges.subscribe(v => this.pocRequiredChanged.emit(v));
          this.PDSactiveIndex = 1;
        }
      }); this.subscriptions.add(sub);
    }
  }
  showEditor = true;
  fetchMasterData(index: number) {
    if (!Array.isArray(this.masterData)) return;
    this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Data fetched from Master' });
    let n = index === 0 ? 'SOC' : 'RFP', d = this.masterData.find((i: any) => i.name === n);
    if (d) {
      this.init = { ...this.init, content_css: environment.APIUrl + d.style };
      this.showEditor = false; setTimeout(() => { this.showEditor = true; });
      if (index === 0) this.SOCForm.patchValue({ comment: d.paragraph_1 || '' });
      else this.RFPForm.patchValue({ comment: d.paragraph_1 || '', poc_required: d.poc });
    }
  }
  getSOCdata() {
    const sub = this.api.getAPI(`/revenue/draft-soc/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`)
      .subscribe({
        next: (r: any) => {
          this.socID = r[0]?.id;
          this.SOCForm.patchValue({ comment: r[0]?.comment });
          this.showEditor = false;
          setTimeout(() => {
            this.init = { ...this.init, content_css: environment.APIUrl + r[0]?.css_file_path };
            this.showEditor = true;
          });
        }
      });
    this.subscriptions.add(sub);
  }
  getRFPdata() {
    const sub = this.api.getAPI(`/revenue/draft-rfp/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`)
      .subscribe({
        next: (r: any) => {
          // this.rfpID = r[0]?.id;
          this.rfpID = r.data?.id;
          this.modeOfTender = r?.mode_tendor ?? r.data?.mode_of_tender ?? r.data?.mode_tendor ?? r?.mode_of_tender ?? null;
          console.log('Mode of Tender fetched:', this.modeOfTender);
          // this.RFPForm.patchValue({ comment: r[0]?.comment, poc_required: r[0]?.poc });
          this.RFPForm.patchValue({ comment: r.data?.comment, noting: r.data?.noting || '', poc_required: r[0]?.poc });
          this.showEditor = false;
          setTimeout(() => {
            this.init = { ...this.init, content_css: environment.APIUrl + r[0]?.css_file_path };
            this.showEditor = true;
          });
        }
      });
    this.subscriptions.add(sub);
  }

  /** True when vendor management (upload vendor files) should be hidden (Open Tender / Single Tender). */
  get hideVendorManagement(): boolean {
    const m = (this.modeOfTender || '').trim();
    return m === 'Open Tender' || m === 'Single Tender' || m === 'Open Tinder';
  }
  confirmSkipStage() {
    const payload = Object.values(this.stagesByCategory).flat().filter((s: any) => s.exists_in_transaction)
      .map((s: any) => ({ proposal: this.payload.proposal_id, criteria: s.id, name: s.name, sequence: s.sequence, skipped: false, remark: s.remark || '' }));
    const sub = this.api.postAPI(`/transaction/evaluation-criteria/${this.payload.proposal_id}/list/`, payload)
      .subscribe((res: any) => this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Criteria added Successfully' }));
    this.subscriptions.add(sub);
  }
  stagesByCategory: { [cat: string]: any[] } = {};
  matrixOrder = ['VENDOR EVALUATION MATRIX', 'TECHNICAL EVALUATION MATRIX', 'COMMERCIAL BID'];
  getCriteriaList() {
    const sub = this.api.getAPI(`/transaction/evaluation-criteria/${this.payload.proposal_id}/list/`)
      .subscribe((res: any) => {
        this.stagesByCategory = res;
        for (const k in res) this.stagesByCategory[k] = res[k].sort((a: any, b: any) => a.sequence - b.sequence);
      });
    this.subscriptions.add(sub);
  }
  getPoC() {
    const sub = this.api.getAPI(`/transaction/poc-criteria/${this.payload.proposal_id}/list/`)
      .subscribe((r: any) => { this.pocstages = r });
    this.subscriptions.add(sub);
  }
  confirmSkipStage2() {
    const payload = (this.pocstages || []).filter((s: any) => s.exists_in_transaction)
      .map((s: any) => ({ proposal: this.payload.proposal_id, criteria: s.id, name: s.name, sequence: s.sequence, skipped: false, remark: s.remark }));
    const sub = this.api.postAPI(`/transaction/poc-criteria/${this.payload.proposal_id}/list/`, payload)
      .subscribe((res: any) => this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Criteria added Successfully' }));
    this.subscriptions.add(sub);
  }
  onPocCheckboxChange(e: any) { if (e.checked) this.getPoC(); }
  get selectedStages() { return this.pocstages?.filter((s: any) => s.exists_in_transaction); }
  getTotalMarks(): number { return this.selectedStages?.reduce((sum: number, s: any) => sum + Number(s.total_mark || 0), 0) || 0; }
  getTotalCutoff(): number { return this.selectedStages?.reduce((sum: number, s: any) => sum + Number(s.cut_off || 0), 0) || 0; }
  setActiveStep(i: number) { this.PDSactiveIndex = i; this.onPDSActiveIndexChange(i); }

  // Vendor Management Event Handlers
  onVendorAdded(event: any): void {
    console.log('Vendor added:', event);
  }

  onVendorUpdated(event: any): void {
    console.log('Vendor updated:', event);
  }

  onVendorDeleted(event: any): void {
    console.log('Vendor deleted:', event);
  }

  onFilesSubmitted(event: any): void {
    console.log('Files submitted:', event);
  }
}
